import { Modal } from "antd";
import PaymentIcon from "../../../assets/images/vectors/SideBarIcons/PaymentIcon";
import { PurchaseLicenseCodeSelector } from "./PurchaseLicenseCodeSelector";

const PurchaseLicenseItemModal = ({
  open,
  setOpen,
  purchaseId,
  editingItem,
  setEditingItem,
  existingItems = [],
  onSaved,
  onPick,
}) => {
  const isEdit = editingItem?.ItemNo != null;

  const handleClose = () => setOpen(false);

  return (
    <Modal
      open={open}
      closable={false}
      onCancel={handleClose}
      // Clearing editingItem mid close-animation would switch the title while fading out.
      afterClose={() => setEditingItem?.(null)}
      footer={null}
      width={1000}
      centered
      destroyOnClose
      title={
        <div className="flex items-center bg-gray-200 p-2 rounded-md">
          <PaymentIcon className="text-[18px] text-black" />
          <span className="text-[14px] font-[Poppins] text-black ml-2">
            {isEdit ? "Edit License item" : "Add License item"}
          </span>
        </div>
      }
    >
      <PurchaseLicenseCodeSelector
        purchaseId={purchaseId}
        existingItems={existingItems}
        editingItem={editingItem}
        onCancel={handleClose}
        onSaved={onSaved}
        onPick={onPick}
      />
    </Modal>
  );
};

export default PurchaseLicenseItemModal;
